export default __webpack_public_path__ + "static/media/Walker's Leggings of the Greensward.dc3c1784.jpg";